<section class="suggestions" (click)="closeSuggestions()">
  <span
    *ngFor="let suggestion of suggestions; let i = index"
    class="suggestions__item"
    [ngClass]="{ 'suggestions__item--active': i === selectedItem }"
    routerLink="/search/{{ suggestion }}"
    >{{ suggestion }}</span
  >
</section>
